import React from "react";

import shenkee from "../images/shenkee.jpg";
import latteexpress from "../images/latteexpress.jpg";
import grillbar from "../images/grillbar.jpg";

const IndexPage = () => (
  <React.Fragment>
    <p className="redoutline">
      We manufacture custom&nbsp;made signs&nbsp;and&nbsp;awnings from the
      San&nbsp;Francisco&nbsp;Bay&nbsp;Area.
    </p>

    <p>
      <img
        className="feature"
        src={shenkee}
        style={{ height: 321, width: 432 }}
      />
    </p>

    <p>
      <img className="feature" src={latteexpress} />
    </p>

    <p>
      <img className="feature" src={grillbar} />
    </p>
  </React.Fragment>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js